import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-rocket-icon',
  standalone: true,
  templateUrl: './rocket-icon.component.html',
  styleUrls: ['./rocket-icon.component.scss']
})
export class RocketIconComponent {
  @Input() width: number | string = 20;
  @Input() height: number | string = 20;
}
